import * as React from "react"

const HighLightUpSVG = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={12} height={7} fill="none" {...props}>
		<path
			fill="#475163"
			fillOpacity={1}
			d="M.7 6.7A.948.948 0 0 1 .425 6c0-.283.092-.517.275-.7L5.3.7c.1-.1.208-.17.325-.212.117-.041.242-.062.375-.063.133 0 .263.025.388.075.125.05.23.117.312.2l4.6 4.6a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275L6 2.8 2.1 6.7a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275Z"
		/>
	</svg>
)

export default HighLightUpSVG
